'use client'

import { PolarEmbedCheckout } from '@polar-sh/checkout/embed'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import Icon from './icon'

const PolarCheckout = ({ checkoutLink, checkoutText, iconOnly, className, product }: { checkoutLink: string, checkoutText: string, iconOnly: boolean, className: string, product: string }) => {

  const pathname = usePathname()

  // Logsnag tracking 
  const tracking = ({channel,product,notify}:{channel: string, product: string, notify: boolean}) => {
    const logsnag = eval('new window.LogSnag({ token: "75f88ac7fb475166c57f6e2ef409a608", project: "bright-themes"})');
    logsnag.track({
      channel: channel,
      event: "Possible purchase",
      description: product,
      icon: "👀",
      tags: {
        path: pathname,
      },
      notify: notify
    })
  }

  useEffect(() => {
    PolarEmbedCheckout.init()
  }, [])

  return (
    <a
      className={className}
      href={checkoutLink}
      data-polar-checkout
      data-polar-checkout-theme="light"
      target="_blank"
      rel="noreferrer"
      data-product={product}
      onClick={() => {
        tracking({channel: 'acquisition', product: product, notify: false});
      }}
    >
      <span className={`${iconOnly ? 'hidden' : ''}`}>{checkoutText}</span>
      {iconOnly && <Icon name="download" className="h-4 w-4" strokeWidth="2" />}
    </a>
  )
}

export default PolarCheckout